import { Button } from 'foundations-components/transitional/components/Button';
import { DropdownCaret } from 'foundations-components/transitional/components/AbstractDropdown';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useState } from 'react';
import { FilterEditorWrapper } from '../Filters/FilterEditorWrapper';
import styled from 'foundations-theming/utils';

// Hack: the foundation component Select use a 8px icon
// to prevent different looking popovers we need to override the internal
// size of the icon
// Taken from https://git.hubteam.com/HubSpot/customer-data-filters/blob/9d2d215651132be1bdb9acc8527cbd7460ea8b4f/customer-data-filters-ui/static-1.33478/js/components/quickFilters/quickFiltersBar/QuickFilterSelect.tsx#L26
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrellisMigrateIconResizer = styled.div.withConfig({
  displayName: "BasePopoverEditorComponent__TrellisMigrateIconResizer",
  componentId: "sc-1hnhm5v-0"
})(["svg{width:7px !important;height:7px !important;}"]);
const BasePopoverEditorComponent = ({
  buttonContent,
  dataTestId,
  hasSelectedValue,
  tooltipContent,
  popoverHeader,
  popoverBody
}) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  return /*#__PURE__*/_jsx(Popover, {
    "data-test-id": `${dataTestId}-popover`,
    open: popoverOpen,
    onOpenChange: () => setPopoverOpen(!popoverOpen),
    placement: 'bottom',
    content: {
      header: popoverHeader,
      body: popoverBody
    },
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: tooltipContent,
      children: /*#__PURE__*/_jsx(FilterEditorWrapper, {
        isSelected: hasSelectedValue,
        children: /*#__PURE__*/_jsxs(Button, {
          "aria-pressed": popoverOpen,
          use: "transparent",
          "data-test-id": dataTestId,
          onClick: () => setPopoverOpen(!popoverOpen),
          size: "small",
          children: [buttonContent, /*#__PURE__*/_jsx(TrellisMigrateIconResizer, {
            children: /*#__PURE__*/_jsx(DropdownCaret, {
              buttonUse: "transparent",
              buttonSize: "small"
            })
          })]
        })
      })
    })
  });
};
export default BasePopoverEditorComponent;